module.exports = __webpack_public_path__ + "70653b4674843410bb392be280c87b2b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/goggles-VR.png
// module id = 2454
// module chunks = 0